import * as yup from "yup";

export const validFileExtensions = {
   image: ["jpg", "gif", "png", "jpeg", "svg", "webp"],
   document: ["pdf", "doc", "docx"],
   all: ["jpg", "gif", "png", "jpeg", "svg", "webp", "pdf", "doc", "docx"],
};

export function isValidFileType(fileName, fileType) {
   return (
      fileName && validFileExtensions[fileType].indexOf(fileName.split(".").pop()) > -1
   );
}

export function getAllowedExt(type) {
   return validFileExtensions[type].map((e) => `.${e}`).toString();
}

export const MAX_FILE_SIZE = 10240000;
export const MAX_FILE_SIZE_MESSAGE = "Max allowed size is 10MB";

export const editfileSchema = yup
   .mixed()
   // .required("Bank Document is required")
   .test("is-valid-type", "Not a valid image type", (value) =>
      typeof value === "string"
         ? true
         : isValidFileType(value && value?.name?.toLowerCase(), "image")
   )
   .test("is-valid-size", MAX_FILE_SIZE_MESSAGE, (value) =>
      typeof value === "string" ? true : value?.size <= MAX_FILE_SIZE
   );
